import { IOffsiteCampaignType } from '../../entities/offsiteCampaign';

export const campaignTypeToIcon = (type: IOffsiteCampaignType) => {
  switch (type) {
    case 'cartAbandonment':
      return 'cart-arrow-down';
    case 'browseAbandonment':
      return 'eye';
    default:
      return 'question';
  }
};
